class Slider {
    constructor(element) {
        this.element = element;
        this.count = this.element.querySelectorAll('.slider-images > li').length;

        this.currentIndex = 0;
        this.hasSlidePos = true;
        this.auto = null;

        this.createSlidePosition();
        this.setNavigation();
        this.setActive(this.currentIndex);
        this.setHeight();
        if(this.count > 1) this.autoPlay();
    }

    setHeight() {
        let CaptionItems = this.element.querySelectorAll('.slider-box > ul li');
        let height = 0;
        [].forEach.call(CaptionItems, (item) => {
            height = Math.max(item.offsetHeight, height);
        });
        if(this.element.querySelector('.slider-box > ul')) {
            this.element.querySelector('.slider-box > ul').style.height = height + 'px';
        }
        
    }

    createSlidePosition() {
        let slidePos = this.element.querySelector('.slide-position');

        if(!slidePos)  {
            this.hasSlidePos = false;
            return;
        }

        // create rectangles
        for(var i = 0; i < this.count; i++) {
            let pos = document.createElement('div');
            pos.classList.add('pos');
            slidePos.appendChild(pos);
        }
    }

    setNavigation() {
        let next = this.element.querySelector('nav .arrow.next');
        let prev = this.element.querySelector('nav .arrow.prev');

        if(this.count <= 1) {
            next.style.display = 'none';
            prev.style.display = 'none';
            return;
        }

        next.addEventListener('click', (e) => {
            e.preventDefault(); 
            clearInterval(this.auto);
            this.next();
        });

        prev.addEventListener('click', (e) => {
            e.preventDefault();
            clearInterval(this.auto);
            this.prev();
        })
    }

    autoPlay() {
        clearInterval(this.auto);
        this.auto = setInterval(() => this.next(), 5000);
    }

    next() {
        if(this.count -1 > this.currentIndex) {
            this.currentIndex += 1;
        }
        else {
            this.currentIndex = 0;
        }
        this.sliderAnimation(this.currentIndex, 'left');
    }

    prev() {
        if(this.currentIndex != 0) {
            this.currentIndex -= 1;
        }
        else {
            this.currentIndex = this.count -1;
        }
        this.sliderAnimation(this.currentIndex, 'right');
        
    }

    setActive(index) {
        let activeListItem = this.element.querySelectorAll('.slider-images > li')[index];
        let activePosItem = this.element.querySelectorAll('.slide-position .pos')[index];
        let activeCaptionItem = this.element.querySelectorAll('.slider-box > ul li')[index];
        let prevActiveListItem = this.element.querySelector('.slider-images > li.active');
        let prevActivePosItem = this.element.querySelector('.slide-position .pos.active');
        let prevActiveCaptionItem = this.element.querySelector('.slider-box > ul li.active');

        if(prevActiveListItem) prevActiveListItem.classList.remove('active');
        if(prevActivePosItem) prevActivePosItem.classList.remove('active');
        if(prevActiveCaptionItem) prevActiveCaptionItem.classList.remove('active');

        if(activeListItem) activeListItem.classList.add('active');
        if(activePosItem) activePosItem.classList.add('active');
        if(activeCaptionItem) activeCaptionItem.classList.add('active');
    }

    sliderAnimation(index, direction) {
        let activeListItem = this.element.querySelectorAll('.slider-images > li')[index];
        let activePosItem = this.element.querySelectorAll('.slide-position .pos')[index];
        let activeCaptionItem = this.element.querySelectorAll('.slider-box > ul li')[index];
        let prevActiveListItem = this.element.querySelector('.slider-images > li.active');
        let prevActivePosItem = this.element.querySelector('.slide-position .pos.active');
        let prevActiveCaptionItem = this.element.querySelector('.slider-box > ul li.active');

        if(prevActiveListItem) {
            prevActiveListItem.classList.remove('active');
            prevActiveListItem.classList.add('leaving-' + direction);
            setTimeout(() => prevActiveListItem.classList.remove('leaving-' + direction), 500);
        }
        if(prevActivePosItem) {
            prevActivePosItem.classList.remove('active');
        }
        if(prevActiveCaptionItem) prevActiveCaptionItem.classList.remove('active');

        if(activeListItem) {
            activeListItem.classList.add('active');
            activeListItem.classList.add('entering-' + direction);
            setTimeout(() => activeListItem.classList.remove('entering-' + direction), 500)
        }
        if(activePosItem) {
            activePosItem.classList.add('active');
        }
        if(activeCaptionItem) activeCaptionItem.classList.add('active');
    }
}